import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs'; 
@Component({
    selector: 'app-routelist',
    template: require('./routelist.component.html'),
    styles: []
})
export class RouteListComponent implements OnInit {

    private columnDefs;
    private rowData;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    routeData: any = [];
    id: string;
    routeLists: any;
    f_ChkNum(p_value) {
        var Num = Number(p_value);
        if(Num){
            return Num;
        }
        return 0;
    }

    static parameters = [ApiService, ActivatedRoute, Router]
    constructor(private apiService: ApiService, private activatedRoute: ActivatedRoute) {
        let parent = this;
        this.columnDefs = [
            { headerName: 'Route Name', field: 'RouteName' },
            { headerName: '	DA Type', field: 'DAType', width: 100 },
            { headerName: 'KM', field: 'KM', width: 100 },
            { headerName: 'No of visit in a Month', field: 'no_Of_Visit_In_A_Month', width: 200 },
            // { headerName: 'Total Dr.', field: 'totaldr', width: 100 },
            { headerName: 'Total Chemist/Retailer', field: 'totalchemist' },
            // {
            //     headerName: 'Approved', field: 'approved', width: 120, pinned: 'right', cellRenderer: function (params) {
            //         var eDiv = document.createElement('div');
            //         eDiv.innerHTML = `<div class="grid_actions"><span class="grid_actions_item" style="cursor: auto;" ><i class="icon-tick"></i></span></div>`;
            //         return eDiv;
            //     }
            // },
            {
                headerName: 'Action', field: 'action', width: 80, pinned: 'right', cellRenderer: function (params) {
                    if (params.data.Is_Delete_Allow && parent.f_ChkNum(params.data.totalchemist) == 0) {
                        var eDiv = document.createElement('div');
                        eDiv.innerHTML = `<div class="grid_actions"><span class="delbtn grid_actions_item" ><i class="icon-delete"></i></span></div>`;
                        var addButton = eDiv.querySelectorAll('.delbtn')[0];
                        addButton.addEventListener('click', function () {
                            parent.disableRoute(params.data.RouteId)
                        })
                        return eDiv;
                    }
                }
            }
        ];

        // this.rowData = [
        //   { sno: '1', rname: 'Delhi To Gurugram', datype: 'L', km: 0, visitmonth: 12, totaldr: 0, totalchemist: 12 },
        //   { sno: '1', rname: 'Delhi To Gurugram', datype: 'L', km: 0, visitmonth: 12, totaldr: 0, totalchemist: 12 },
        //   { sno: '1', rname: 'Delhi To Gurugram', datype: 'L', km: 0, visitmonth: 12, totaldr: 0, totalchemist: 12 },
        //   { sno: '1', rname: 'Delhi To Gurugram', datype: 'L', km: 0, visitmonth: 12, totaldr: 0, totalchemist: 12 }
        // ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }

    ngOnInit() {
        this.activatedRoute.queryParams.subscribe(params => {
            this.id = params['id'];
            this.getRouteList();
        });

    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
        this.api.hideOverlay();
        this.api.sizeColumnsToFit();

    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'RouteList' });
    }

    onFilterTextBoxChanged() {
        console.log('on filter text')
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    disableRoute(id) {
        this.busy = this.apiService.disableRoute({ Route_ID: id }).subscribe((res: any) => {
            alert(res.msg);
            this.getRouteList();
        })
    }

    getRouteList() {
        let id = this.id;
       this.busy = this.apiService.getRouteList(id).subscribe((res: any) => {
            this.routeLists = res.data;
            console.log('route Lists', res.data);
            setTimeout(function (self) {
                self.api.sizeColumnsToFit();
            }, 200, this);
        })
    }
}
